import FadedText from "@components/FadedText";
import { AltText, Column, LineClamp, Row } from "@components/Layout";
import { Template } from "@components/Template";
import { Image, Progress } from "@kobalte/core";
import { playerContext } from "@layouts/App/context/Player";
import { formatPlayTime } from "@src/app/utils";
import { BsDot } from "solid-icons/bs";
import { FaSolidPause, FaSolidPlay } from "solid-icons/fa";
import { Show, createMemo, useContext } from "solid-js";
import { MobilePlayerWrapper, PlayerControl, ProgressFill, ProgressTrack, TrackImage } from "./styled";

const MobilePlayer = () => {
	const { player, canGoNext, canGoPrevious, handleTogglePlayer, setPlayer, handleSetProgress } =
		useContext(playerContext);

	const track = createMemo(() => player.queue[player.track]);

	const trackLength = createMemo(() => {
		const tr = track();
		if (tr && tr.type !== "RADIO") return tr.length ?? 0;
		return 0;
	});

	const getProgress = () => {
		const l = trackLength();
		const elapsed = player.time < l ? player.time : l;
		return Number.isNaN(elapsed / l) ? 0 : elapsed / l;
	};

	const handleProgressClick = (e: MouseEvent & { currentTarget: HTMLSpanElement }) => {
		const bounds = e.currentTarget.getBoundingClientRect();
		const x = e.clientX - bounds.left;
		const xPerc = x / bounds.width;
		handleSetProgress(xPerc);
	};

	return (
		<Show when={player.track >= 0 && player.track < player.queue.length}>
			<MobilePlayerWrapper gap="15px" alignItems="center">
				<Progress.Root
					value={getProgress() * 100}
					style={{ width: "100%", cursor: "pointer" }}
					onclick={handleProgressClick}
				>
					<ProgressTrack>
						<ProgressFill />
					</ProgressTrack>
				</Progress.Root>
				<Row padding="0 10px" gap="10px" alignItems="stretch">
					<TrackImage>
						<Image.Img src={track()?.photo} />
						<Image.Fallback>
							<Template w="100%" h="100%" />
						</Image.Fallback>
					</TrackImage>
					<Column w="100%">
						<h4 class={LineClamp}>{track()?.name}</h4>
						<Row alignItems="center" maxWidth="200px">
							<FadedText fontSize="12px" class={LineClamp} style={{ width: "max-content" }}>
								{track()?.author}
							</FadedText>
							<AltText lineHeight={0}>
								<BsDot />
							</AltText>
							<FadedText fontSize="12px" style={{ width: "max-content", "white-space": "nowrap" }}>
								{formatPlayTime(player.time, { s: true })}&nbsp;/&nbsp;
								{formatPlayTime(trackLength() - player.time >= 0 ? trackLength() - player.time : 0, {
									s: true,
								})}
							</FadedText>
						</Row>
					</Column>
					<Column justifyContent="center" w="max-content">
						<PlayerControl disabled={!player.queue[player.track]} onclick={() => handleTogglePlayer(true)}>
							<Show when={player.playing} fallback={<FaSolidPlay font-size="22px" />}>
								<FaSolidPause font-size="22px" />
							</Show>
						</PlayerControl>
					</Column>
				</Row>
			</MobilePlayerWrapper>
		</Show>
	);
};
export default MobilePlayer;
